import { render, staticRenderFns } from "./YearToggle.vue?vue&type=template&id=c36746e2&scoped=true&"
import script from "./YearToggle.vue?vue&type=script&lang=js&"
export * from "./YearToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36746e2",
  null
  
)

export default component.exports